// extracted by mini-css-extract-plugin
module.exports = {"container":"pensions-page_container__1M-Pc","blue-btn":"pensions-page_blue-btn__1SpeX"};